<template>
    <v-card elevation="2" id="area-de-impresion">
        <v-row>
            <v-col :key="rounded">
                <h2>Diseño de Factura</h2>

                <v-data-table :headers="headers" :items="desserts" :items-per-page="5" class="elevation-1"></v-data-table>
            </v-col>
        </v-row>


        <v-btn depressed color="primary" @click="generarPDF">
            Primary
        </v-btn>
    </v-card>
</template>

<script>
import html2pdf from 'html2pdf.js';

export default {
    name: 'GenerarFactura',

    data: () => ({

    }),
    methods: {
        generarPDF() {
            let element = document.getElementById('area-de-impresion');

            var opt = {
                margin: 0.1,
                filename: 'myfile.pdf',
                image: { type: 'jpeg', quality: 1 },
                html2canvas: { scale: 3 },
                //jsPDF: { unit: 'in', format: [5.5,8.5], orientation: 'landscape' }
                jsPDF: { unit: 'in', format: 'letter', orientation: 'portrait' }
            };

            html2pdf().from(element).set(opt).toPdf().get('pdf').then(function (pdf) {
                window.open(pdf.output('bloburl'), '_blank');
            });
            // New Promise-based usage:
            //html2pdf().from(element).set(opt).output('dataurlnewwindow');
        }
    }
}
</script>